<template>
    <v-expansion-panels v-if="currentTask > 0" class="mb-5">
        <v-expansion-panel v-if="proceduresStore.taskSteps">
            <v-expansion-panel-header class="procedure-expansion-panel-header">
                <v-stepper
                    non-linear
                    v-model="currentTask"
                    :value="currentTask"
                    class="custom-stepper"
                >
                    <v-stepper-header tile flat plain >
                        <template v-for="(step, index) in proceduresStore.taskSteps">
                            <v-stepper-step :step="index + 1" :key="'stepper_'+index" :complete="(index + 1) < currentTask" class="dex-ter">
                                <template v-if="currentTask === (index +1)">
                                    {{ step.formulario_nombre }}
                                </template>

                            </v-stepper-step>

                            <v-divider :key="'divider_'+index"></v-divider>
                        </template>

                        <v-stepper-step :step="proceduresStore.taskSteps.length + 1" class="dex-ter">
                            <template v-if="currentTask == (proceduresStore.taskSteps.length + 1)">
                                Confirmación
                            </template>
                        </v-stepper-step>
                    </v-stepper-header>
                    <div class="text-center my-1 d-flex justify-center align-center">
                        Etapas del trámite: {{tramite_id}} <v-icon  style="padding-bottom:10px">fas fa-sort-down</v-icon>
                    </div>
                </v-stepper>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-stepper
                    v-model="currentTask"
                    vertical
                    class="custom-stepper"
                >
                    <template v-for="(step, index) in proceduresStore.taskSteps.slice(0,pasosPrimerColumna)">
                        <v-stepper-step
                            class="dex-ter"
                            :key="'stepper_'+index "
                            :complete="(index + 1) < currentTask"
                            :step="index + 1"
                        >
                            {{ step.formulario_nombre }}
                        </v-stepper-step>

                        <!-- <v-stepper-content :step="index + 1" :key="'divider_'+index">
                        </v-stepper-content> -->
                    </template>


                </v-stepper>
                <v-stepper
                    v-model="currentTask"
                    vertical
                    class="custom-stepper"
                >
                    <template v-for="(step, index) in proceduresStore.taskSteps.slice(pasosPrimerColumna)">
                        <v-stepper-step
                            class="dex-ter"
                            :key="'stepper_'+index"
                            :complete="(index + 1) < currentTask"
                            :step="Math.floor(index + pasosPrimerColumna + 1 )"
                        >
                            {{ step.formulario_nombre }}
                        </v-stepper-step>

                        <!-- <v-stepper-content :step="index + 1" :key="'divider_'+index">
                        </v-stepper-content> -->
                    </template>

                    <v-stepper-step :step="proceduresStore.taskSteps.length + 1" class="dex-ter">
                        Confirmación
                    </v-stepper-step>

                    <v-stepper-content :step="proceduresStore.taskSteps.length + 1">
                    </v-stepper-content>

                </v-stepper>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import Vue from 'vue';
    import {mapState} from "vuex";

    export default {
        name: 'Tasksteps',
        props: ['currentTask', 'tramite_id'],
        data(){
            return {
                pasosPrimerColumna: 6
            }
        },
        computed: {
            ...mapState({proceduresStore: state => state.procedures}),
        },
        watch:{
            '$store.state.procedures.taskSteps'(){
                Vue.nextTick(() => {
                    this.pasosPrimerColumna = ( this.proceduresStore.taskSteps.length/2 ) + 1
                    // this.pasosPrimerColumna = aux

                })
            }
        }

    };
</script>
<style >
    .custom-stepper{box-shadow: none}
    .procedure-expansion-panel-header{
        padding: 0 16px 0 0;
    }
    .v-expansion-panels{
        z-index: unset !important;
    }
    .v-sheet.v-stepper:not(.v-sheet--outlined) {
        box-shadow: unset !important;
    }
    .v-application .primary {
        background-color: #15212F !important;
        border-color: #15212F !important;
    }
    .v-expansion-panel-content__wrap{
        display: flex;
    }
    .v-stepper--vertical{
        width: 50%;
    }
    .v-stepper--vertical .v-stepper__step{
        padding: 0px 24px 16px;
    }
</style>
